import { render, staticRenderFns } from "./addPartners.vue?vue&type=template&id=13fa8202&lang=pug"
import script from "./addPartners.vue?vue&type=script&lang=js"
export * from "./addPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports